








































import { Toast } from '@ks/sharp-ui';
import { Vue, Component, Watch } from 'vue-property-decorator';
import PayCounterDialog from '@/views/Comsume/PayCounterDialog/index.vue';
import KsCoinIapListDialog from '@/views/Comsume/KsCoinIapListDialog.vue';
import ExpireDialog from '@/views/Comsume/ExpireDialog.vue';
import { getOrderPrepayInfo } from '@/services/detail/index';
import { showAccountExceptionDialog } from '@/utils/index';
import { feedbackUrl } from '@/constant/index';
import { stringifyQuery } from '@/utils/url';
import {
    payForQa,
    payForCourse,
    checkPayCourse,
    checkPayQa,
    setSettingEntryForCourse,
} from '@/utils/pay';
import { getQaPreOrderInfo } from '@/services/detail/index';
import model from '../Detail/model';
import { CommodityTradeInfo } from '@/views/Detail/model';
import * as Sentry from '@sentry/browser';
import PV from '@/components/PV/index.vue';
import yoda, { showConfirmDialog, showAlertDialog } from '@/yoda';
import { ActivityIndicator } from '@ks/sharp-ui';

@Component({
    components: {
        PayCounterDialog,
        KsCoinIapListDialog,
        ExpireDialog,
        PV,
    },
})
export default class PayCounter extends Vue {
    model = model;
    isRefreshing = false;
    isShowPayCounterDialog = false;
    isShowKsCoinIapListDialog = false;
    isPaying: boolean = false;
    showExpire: boolean = true;
    ksCoinIapList = [];

    product: any = {};
    productType = 'paidContent';
    useKscoinPay = false;
    professionId = '';
    questionId = '';
    ksCoin = 0;
    price = 0;
    userBalance = 0;
    userStatus = 0;
    courseId = 0;
    userBanned = false;
    commodityId = '';
    expireTime = '';

    get extInfo() {
        try {
            return JSON.parse(decodeURIComponent(this.$route.query.extInfo as string));
        } catch (error) {
            return {};
        }
    }
    get isShowExpireDialog() {
        const { commodityTradeInfo = {} as CommodityTradeInfo } = { ...this.model };
        const { skuList = [] } = commodityTradeInfo || {};
        return (
            !!skuList.find(item => item && item.specs[1] && +item.specs[1].value !== -1) &&
            this.showExpire
        );
    }
    toRMB(num) {
        return Number((num / 100).toFixed(2));
    }

    async mounted() {
        this.ksCoin = +this.extInfo.kscoinPrice || 0;
        this.price = +this.extInfo.price || 0;
        this.userBalance = +this.extInfo.userBalance || 0;
        this.userStatus = +this.extInfo.userStatus || 0;
        this.userBanned = this.extInfo.userBanned;
        this.courseId = +this.extInfo.relatedId || 0;
        // 问答参数
        this.productType = this.extInfo.type || 'paidContent';
        this.professionId = this.extInfo.professionId || '';
        this.questionId = this.extInfo.questionId || '';
        this.useKscoinPay = !!this.extInfo.useKscoinPay;
        this.model.useKscoinPay = this.useKscoinPay;
        this.logWhenPayCounterShow(true);
        this.product = {
            name: this.extInfo.commodityName || '',
            originPrice: this.price,
            price: this.price,
            discount: 0,
        };
        if (this.model.useKscoinPay) {
            await this.fetchKsCoinIapList();
        }

        if (this.productType === 'paidContent') {
            if (yoda.isInYoda) {
                window.ksLog?.sendCountTag('Lightks_Native_Trail_PayCounter');
            }
            // 详情页接口兜底
            const detailRes: boolean = await this.model.getCourseDetail(this.courseId);

            this.product = {
                name: this.extInfo.commodityName || '',
                voucherList: this.model.commodityTradeInfo?.recommendedCombinationVoucherList,
                price: this.model.commodityTradeInfo?.actualPrice,
                originPrice: this.model.inSecKill
                    ? this.model.secKillPrice
                    : this.model.originPrice,
                courseId: this.courseId,
            };

            this.useKscoinPay = this.model.useKscoinPay;
            if (!detailRes) {
                setTimeout(() => this.close(), 200);
            }
        }

        this.showExpire = this.isShowExpireDialog;
        await this.handleExpireDiscount();
        this.$emit('loaded');
        this.checkUserBanned();
    }
    async handleExpireDiscount() {
        if (this.model.canDiscount && this.isShowExpireDialog) {
            const [lastSpecs] = [...(this.model.commodityTradeInfo?.skuList ?? [])].reverse();
            const interval = (lastSpecs && +lastSpecs.specs[1].value) || 0;
            const expireTime = interval === -1 ? interval : new Date().getTime() + interval;
            await this.expireSubmit({
                expireTime,
                ...lastSpecs,
            });
        }
    }
    checkUserBanned() {
        if (this.userBanned) {
            const content = this.model.canDiscount ? '无法使用优惠券' : '暂时无法购买。';
            showAlertDialog({
                title: '温馨提示',
                content: `您的账号处于异常状态，${content}`,
                confirmBtnText: '我知道了',
                onConfirm: () => this.close(),
            });
            return false;
        }
        return true;
    }
    chargeSuccess(ret, isCoinEnough) {
        Toast.success('充值成功');
        // 刷新一下 重置推荐重置哪一项
        this.fetchOrderPrepayInfo().then((res: any) => {
            if (res.result === 1) {
                this.fetchKsCoinIapList();
                if (isCoinEnough) {
                    this.isShowKsCoinIapListDialog = false;
                    if (this.productType === 'eduqa') {
                        this.doPayForQa();
                    } else {
                        this.doPayForCourse();
                    }
                }
            } else {
                Toast.error(res.error_msg);
            }
        });
    }
    chargeFail(e) {
        // Log: 快币收银台
        if (yoda.isInYoda) {
            window.ksLog?.sendCountTag('Lightks_KsCoin_ChargeFail');
            Sentry.configureScope(scope => {
                scope.setExtra('errorInfo', e);
                // scope.clear();
            });
            Sentry.captureException(new Error('LIGHTKS-KNOWLEDGE: Recharge KsCoin Fail'));
        }
        Toast.error(e.error_msg || '充值失败');
    }
    notifyNative(type, message = '', data = {}) {
        const typeMap = {
            success: {
                payResult: 1,
                message,
            },
            cancel: {
                payResult: 2,
                message,
            },
            fail: {
                payResult: 3,
                message,
            },
            userBanned: {
                payResult: 4,
                message,
                url: encodeURIComponent(feedbackUrl),
            },
        };
        if (type !== 'success') {
            if (type === 'fail' && yoda.isInYoda) {
                Sentry.configureScope(scope => {
                    scope.setExtra('errorInfo', typeMap[type]);
                    // scope.clear();
                });
                Sentry.captureException(new Error('LIGHTKS-KNOWLEDGE: Pay Counter Pay Error'));

                this.$sendLog.pay({
                    name: 'NATIVE_PAY_FAIL',
                    ext: typeMap[type],
                });
            }
        }
        if (this.productType === 'eduqa') {
            window.parent.postMessage(
                { ...typeMap[type], ...data, messageType: 'notifyNative' },
                '*',
            );
        } else {
            this.$go(`kwai://vision/pay-counter?${stringifyQuery(typeMap[type])}`);
        }
    }
    close() {
        this.isShowPayCounterDialog = false;
        this.notifyNative('cancel', '支付取消');
    }
    expireSubmit({ commodityId, expireTime, kscoinPrice, unitPrice }) {
        this.showExpire = false;
        this.ksCoin = kscoinPrice;
        this.commodityId = commodityId;
        this.expireTime =
            expireTime === -1 ? expireTime : expireTime + this.model.serverTimeAdjustment;
        this.product = {
            name: this.extInfo.commodityName || '',
            originPrice: unitPrice,
            price: unitPrice,
            discount: 0,
        };
    }
    async pay(params: { giftAddressId?: number; remark?: string } = {}) {
        this.isPaying = true;
        this.$sendLog.pay({
            name: 'NATIVE_PAY_START',
        });
        if (!this.checkUserBanned()) {
            return;
        }
        // 问答需要检查价格是否变化
        if (this.productType === 'eduqa') {
            const res: any = await getQaPreOrderInfo(this.professionId);
            if (res.result === 1) {
                if (+res.data.profession.kscoinPrice !== this.ksCoin) {
                    Toast.info('该问答定价已更新，需刷新价格后再进行支付');
                    return;
                }
            }
        } else if (yoda.isInYoda) {
            window.ksLog?.sendCountTag('Lightks_Native_Trail_BuyCourse');
        }
        if (this.userStatus !== 1) {
            this.isShowPayCounterDialog = false;
            this.$log2('Card', 'Account_Exception_Trial', 'Impression');
            showAccountExceptionDialog(
                () => {
                    this.$log2('Button', 'Account_Exception_Trial_Confirm', 'Click');
                    this.notifyNative('userBanned');
                },
                () => {
                    this.$log2('Button', 'Account_Exception_Trial_Cancel', 'Click');
                    this.notifyNative('fail');
                },
            );
            return;
        }
        // 余额不足且不是全额抵扣券
        if (this.model.useKscoinPay && this.userBalance < this.product.price / 10) {
            this.isShowPayCounterDialog = false;
            this.isShowKsCoinIapListDialog = true;
            return;
        }
        if (this.productType === 'eduqa') {
            await this.doPayForQa();
        } else {
            await this.doPayForCourse(params);
        }
        this.isPaying = false;
    }
    async doPayForQa() {
        // 快币支付的toast提示文案
        if (this.useKscoinPay) {
            Toast.loading('正在确认支付结果...');
        }
        const { professionId, questionId } = this;
        await payForQa({
            professionId,
            questionId,
            channel: 'qa_trial',
            useKscoinPay: this.useKscoinPay,
        })
            .then(res => this.onPaySuccess(res))
            .catch(e => {
                this.$sendLog.pay({
                    name: 'NATIVE_DOPAYFOREDUQA_FAIL',
                    ext: e,
                });
                Toast.error(e.error_msg || e.message);
                this.close();
            })
            .finally(() => Toast.hide());
    }
    async doPayForCourse(params: { giftAddressId?: number; remark?: string } = {}) {
        // 快币支付的toast提示文案
        if (this.model.useKscoinPay) {
            Toast.loading('正在确认支付结果...');
        }
        const { commodityId, expireTime } = this;
        const orderParam: Record<string, any> = {
            courseId: this.courseId,
            channel: 'native_trial',
            dc: '',
            useKscoinPay: this.useKscoinPay,
            commodityId,
            expireTime,
            price: this.product.price,
            activityInfo: this.model.inSecKill ? this.model.activityInfo : null,
            ...params,
        };
        if (this.model.vouchers.length) {
            orderParam.voucherList = this.model.vouchers.map(voucher => ({
                voucherId: voucher.voucherId,
                promotionPlatform: voucher.promotionPlatform,
            }));
        }
        // 支付前还要判断如果进入页面的时候有秒杀活动，付款时候是否已经超时结束了
        // 为了避免支付收银台调起时候还在秒杀 但付款时秒杀结束了
        const isSecKillExpire = !!(this.model.activityInfo?.activityId && !this.model.inSecKill);
        if (isSecKillExpire) {
            orderParam.activityInfo = null;
            showConfirmDialog({
                title: '温馨提示',
                content: '秒杀活动已结束，是否以原价继续购买？',
                confirmBtnText: '立即支付',
                cancelBtnText: '再想想',
                onConfirm: () => {
                    this.payForCourseHandler(orderParam);
                },
                onCancel: () => {
                    Toast.hide();
                    this.close();
                },
            });
        } else {
            this.payForCourseHandler(orderParam);
        }
    }
    async payForCourseHandler(orderParam) {
        await payForCourse(orderParam)
            .then(res => this.onPaySuccess(res))
            .catch(e => {
                this.$sendLog.pay({
                    name: 'NATIVE_DOPAYFORCOURSE_FAIL',
                    ext: e,
                });
                if (e.result !== 0) {
                    Sentry.configureScope(scope => {
                        scope.setExtra('errorInfo', { courseId: this.courseId, ...e });
                        // scope.clear();
                    });
                    Sentry.captureException(
                        new Error('LIGHTKS-KNOWLEDGE: Native Buy Course PayForCourse Error'),
                    );
                }
                Toast.error(e.error_msg || e.message);
                this.close();
            })
            .finally(() => Toast.hide());
    }
    onPaySuccess(ret) {
        this.isShowPayCounterDialog = false;
        if (ret.result === 1 || ret.result === 412) {
            const id = this.productType === 'paidContent' ? this.courseId : ret.orderId;
            this.verifyResult(id);
            return;
        }
        if ([15, -999, -998, -997].includes(ret.result)) {
            Toast.error(`${ret.error_msg} [${ret.result}]` || '当前访问人数较多，请稍候重试');
        } else if (ret.result && ret.error_msg) {
            Toast.error(ret.error_msg);
        }
        this.$sendLog.pay({
            name: `NATIVE_DOPAYFOR${this.productType.toUpperCase()}_FAIL`,
            ext: ret,
        });
    }
    // 购买回调
    verifyResult(id) {
        const fn = this.productType === 'paidContent' ? checkPayCourse : checkPayQa;
        fn(id)
            .then((res: any) => {
                switch (this.productType) {
                    case 'paidContent':
                        if (res.data.courseSettingInfo && res.data.courseSettingInfo.text) {
                            setSettingEntryForCourse(res.data.courseSettingInfo);
                        }
                        break;
                    case 'eduqa':
                        break;
                }
                this.notifyNative('success', '支付成功', res.data);
            })
            .catch(e => {
                Toast.error(e.error_msg || e.message);
                this.notifyNative('fail', e.error_msg || e.message);
            });
    }
    fetchOrderPrepayInfo() {
        this.isRefreshing = true;
        return getOrderPrepayInfo()
            .then((res: any) => {
                if (res.result === 1) {
                    this.userBalance = res.data.userBalance;
                    this.userStatus = res.data.userStatus;
                }
                return res;
            })
            .catch(e => {
                Toast.error(e.error_msg || e.message);
            })
            .finally(() => {
                this.isRefreshing = false;
            });
    }
    async fetchKsCoinIapList() {
        ActivityIndicator.show();
        return this.model
            .fetchKsCoinIapList()
            .then((res: any) => {
                if (res.result !== 1) {
                    if ('result' in res) {
                        Toast.error(res.error_msg);
                    } else {
                        this.$emit('to-error');
                    }
                } else {
                    this.ksCoinIapList = res.data || [];
                }
                return res;
            })
            .catch(e => {
                Toast.error(e.error_msg);
            })
            .finally(() => {
                ActivityIndicator.hide();
            });
    }
    @Watch('isShowPayCounterDialog')
    logWhenPayCounterShow(val) {
        val &&
            this.$log2('CARD', 'PayCounter_Trial', 'Impression', {
                isCoinEnough: this.ksCoin <= this.userBalance,
            });
    }
    @Watch('isShowKsCoinIapListDialog')
    logWhenKsCoinIapListShow(val) {
        val && this.$log2('CARD', 'KsCoinIapList_Trial', 'Impression');
    }
    @Watch('showExpire')
    onShowExpire(newVal) {
        if (newVal) {
            this.isShowPayCounterDialog = this.isShowKsCoinIapListDialog = false;
        } else if (this.useKscoinPay || this.model.vouchers.length || this.model.gifts.length) {
            this.isShowPayCounterDialog = true;
        } else {
            switch (this.productType) {
                case 'paidContent':
                    if (this.model.canDiscount) {
                        this.isShowPayCounterDialog = true;
                    } else {
                        this.doPayForCourse();
                    }
                    break;
                case 'eduqa':
                    this.doPayForQa();
                    break;
            }
        }
    }
}
